import UserImage1 from "../../../shared/assets/user-images/user-1.webp";
import UserImage2 from "../../../shared/assets/user-images/user-2.webp";
import UserImage3 from "../../../shared/assets/user-images/user-3.webp";
import UserImage4 from "../../../shared/assets/user-images/user-4.webp";
import UserImage5 from "../../../shared/assets/user-images/user-5.webp";
import UserImage6 from "../../../shared/assets/user-images/user-6.webp";
import UserImage7 from "../../../shared/assets/user-images/user-7.webp";
import UserImage8 from "../../../shared/assets/user-images/user-8.webp";
import UserImage9 from "../../../shared/assets/user-images/user-9.webp";

export const mockUserImages = [
	{
		imageId: 1,
		imageSrc: UserImage1,
	},
	{
		imageId: 2,
		imageSrc: UserImage2,
	},
	{
		imageId: 3,
		imageSrc: UserImage3,
	},
	{
		imageId: 4,
		imageSrc: UserImage4,
	},
	{
		imageId: 5,
		imageSrc: UserImage5,
	},
	{
		imageId: 6,
		imageSrc: UserImage6,
	},
	{
		imageId: 7,
		imageSrc: UserImage7,
	},
	{
		imageId: 8,
		imageSrc: UserImage8,
	},
	{
		imageId: 9,
		imageSrc: UserImage9,
	},
];
